import ClubSearch from '@presenters/web/pages/ClubSearch';

export default ClubSearch;
